// extracted by mini-css-extract-plugin
export default {"threadsWrapper":"MdtGroups_threadsWrapper__JL3QE","search":"MdtGroups_search__SJ-pt","toggleButton":"MdtGroups_toggleButton__GL8UV","error":"MdtGroups_error__+BGCO"};